import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toHandlers as _toHandlers, mergeProps as _mergeProps, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-146b1341"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["required"]
const _hoisted_2 = ["src", "alt"]

import { FontOptions } from "./FontOptions";
import {defineModel, nextTick, ref, watch} from "vue";
import {useStore} from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'FontSelect',
  props: {
    "modelValue": { required: true },
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props) {

const store = useStore();

const model = _useModel(__props, "modelValue");
const select = ref(null);
const kpsSettings = window.measurementSelectorVariables;
const internalModel = ref(model);

watch( internalModel, ( newValue: string ) => {
	updateModel( newValue );
} );

const updateModel = async (newValue: string|number) => {
	await loadFont(newValue);
	model.value = newValue;
};

async function setPosition(): Promise<void> {
	await nextTick();
	const active = select.value.$el.querySelector(
		".vs__dropdown-menu .vs__dropdown-option--selected"
	);

	if (active) {
		setTimeout(() => {
			active.scrollIntoView({ behavior: "smooth", block: "end" });
		}, 200);
	}
}

async function loadFont(font): Promise<void> {
	const fontObject = store.getters.getSelectedFontObject;

	if ( fontObject !== undefined ) {
		return fontObject;
	}

	await store.dispatch( "loadFont", font, { root: true } );
}


return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(_component_v_select, {
    modelValue: internalModel.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalModel).value = $event)),
    options: _unref(FontOptions),
    class: "measurements-selector__font-select",
    inputId: "measurements-selector-font-select",
    placeholder: _ctx.$i18n.text.selectFont,
    ref_key: "select",
    ref: select,
    onOpen: setPosition
  }, {
    search: _withCtx(({ attributes, events }) => [
      _createElementVNode("input", _mergeProps({
        class: "vs__search",
        required: !model.value
      }, attributes, _toHandlers(events, true)), null, 16, _hoisted_1)
    ]),
    option: _withCtx((option) => [
      _createElementVNode("img", {
        src: _unref(kpsSettings).fontDirUrl + option.label + '-v1.png',
        alt: option.label,
        loading: "lazy"
      }, null, 8, _hoisted_2)
    ]),
    _: 1
  }, 8, ["modelValue", "options", "placeholder"]))
}
}

})